import React, { useState, useEffect } from "react";
import { Form, Grid, Alert } from "tabler-react";
import { Modal, Button } from "react-bootstrap";
import useForm from "../../effects/useForm";
import { post, put } from "../../httpUtils";
import { useToasts } from "react-toast-notifications";

function StoreForm(props) {
  const { addToast } = useToasts();
  const { handleChange, handleSubmit, setInitialValues, values } = useForm(
    submit
  );
  const [errors, setErrors] = useState([]);
  const { item } = props;
  const isEdit =
    typeof item !== "undefined" && item !== null && Object.keys(item).length;
  const currentItemValues = isEdit ? values : item || {};
  useEffect(() => {
    if (
      typeof item !== "undefined" &&
      props.item !== null &&
      Object.keys(props.item).length
    ) {
      setInitialValues(props.item);
    }
  }, [props.item]);
  async function submit(data) {
    //validate
    const { _id, ...formValues } = data;
    try {
      if (!isEdit) {
        await post(`/inventory/store`, formValues);
      } else {
        await put(`/inventory/store/${item._id}`, formValues);
      }
      addToast("Store Created Successfully", { appearance: "success" });
      props.onHide();
    } catch (e) {
      if (e.errors) {
        setErrors(e.errors);
      } else {
        setErrors(["An error occurred"]);
      }
    }
  }
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>
            {!item || item.name === undefined
              ? "Add new store"
              : `Edit ${item.name}`}
          </Modal.Title>{" "}
          <Button onClick={props.onHide} variant="outline-danger" size="sm">
            X
          </Button>
        </Modal.Header>
        <Modal.Body>
          {errors.map((error) => (
            <Alert type="danger">{error}</Alert>
          ))}
          <Form.FieldSet className="NewItem">
            <Grid>
              <Grid.Row>
                <Grid.Col width={6}>
                  <Form.Group label="Store name">
                    <Form.Input
                      name="name"
                      onChange={handleChange}
                      value={currentItemValues.name}
                    />
                  </Form.Group>
                </Grid.Col>
                <Grid.Col width={6}>
                  <Form.Group label="Store location">
                    <Form.Input
                      name="location"
                      onChange={handleChange}
                      value={currentItemValues.location}
                    />
                  </Form.Group>
                </Grid.Col>
              </Grid.Row>
            </Grid>
          </Form.FieldSet>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" onClick={props.onHide}>
            <i class="fe fe-x mr-2"></i>
            Close
          </Button>
          <Button type="submit" variant="outline-success">
            <i class="fe fe-check mr-2"></i>
            {!item || !item.name ? `Add new item` : `Update item`}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
export default StoreForm;
